import React from "react";
import { Route, Routes } from "react-router-dom";
import ForecastBatchList from './List';
import ForecastBatchDetail from './Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    ForecastDate: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    CostForecast: { visible: false, label: '', required: false },
    ProjectOrders: { visible: false, label: '', required: false }
};

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const workflowItem = workflowsQA[wfid];
    const fields = { ...defaultFields };

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.ForecastDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.FORECASTDATE"], required: true };
    fields.Details = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };
    fields.CostForecast = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COSTFORECAST"], required: true };

    //batchForecastForPackagedContractEnabled
    fields.ProjectOrders = { visible: !!workflowsQA['72'] && contract.ispackaged, label: workflowsQA['72']?.notificationName, required: true };

    var typeFieldEnabled = false;
    var clauses = [];

    typeFieldEnabled = placeholdersQA.CostForecastClausesEnabled
            .values.find((phItem) => phItem.field === 'CostForecastClausesEnabled').isActive;

    clauses = placeholdersQA.CostForecastClauses
            .values.filter(item => item.isActive === true);

    fields.Type = { visible: typeFieldEnabled, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };

    fields.Type.clauses = clauses;

    return fields;
}

class ForecastBatchRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<ForecastBatchList
                            {...this.props}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={'BatchCostForecast'}
                        />}

                    />
                    <Route
                        path={'/:batchid/*'}
                        exact
                        element={<ForecastBatchDetail
                            {...this.props}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            documentType={'DocumentCostForecast'}
                            notificationType={'BatchCostForecast'}
                        />}
                    />
                </Routes>
            </>
        );
    }
}

export default ForecastBatchRouter;